/**
 * Created by mly on 2017/12/19.
 */
const util = {
    invoiceType(type_code) {
        let text;
        if (type_code === 0) {
            text = '普票';
        } else if (type_code === 1) {
            text = '专票';
        } else {
            text = '未设置';
        }
        return text;
    }
};

export default util;